import React, { useState } from "react";

const PolicyOwnerReview = ({
  ownerFname,
  ownerLname,
  Policy,

  email,
  phone,
  Driver,
  GoBack,
  GoNext,
  toast,
  setIsLoading,
  isLoading,
}) => {
  const [driverDetails, setDriverDetails] = useState({
    CPR: Driver.cpr,
    Fname: Driver.firstName,
    Lname: Driver.lastName,
    Email: Driver.email,
    PhoneNumber: '+973' + Driver.phone.replace(/\D/g, '').replace(/^973/, '').slice(-8),
  });

  onsubmit = async () => {
    var res = await CreatePlan();
    console.log("API URL:", process.env.REACT_APP_DRIVER_API);
    setIsLoading(false);
    if (res?.msg == "Plan created or updated") {
      GoNext();
    }
  };
  const CreatePlan = async () => {
    
    const url = process.env.REACT_APP_WEB_API + "Sbdrive/CreateOrUpdatePlan";
    const data = {
      PolicyNumber: Policy, // Use the search string here
      driver: driverDetails,
      PlateType: "PVT",
    };

    try {
      setIsLoading(true);
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        toast.error(errorDetails.Message, {
          style: {
            background: "#ffcccc",
            color: "black",
            fontWeight: "bold",
          },
        });
        throw new Error("Failed to login");
      }

      const result = await response.json();
      return result;
      //navigate('/requests');
    } catch (error) {
      setIsLoading(false);
      toast.error("Something went wrong", {
        style: {
          background: "#ffcccc",
          color: "black",
          fontWeight: "bold",
        },
      });
      console.error("Error", error);
    }
  };
  return (
    <div className="bg-white p-4 border rounded-md">
      <div className="px-4 sm:px-0">
        <h3 className="text-base/7 font-semibold text-gray-900">
          Policy Owner
        </h3>
      </div>
      <div className="mt-6 border-t border-gray-100">
        <dl className="divide-y divide-gray-100">
          <InfoRow label="First Name" value={ownerFname} />
          <InfoRow label="Last Name" value={ownerLname} />
          <InfoRow label="Policy Number" value={Policy} />
          <InfoRow
            label="Email address"
            value={email ?? "Need to add email in core before activating"}
          />
          <InfoRow
            label="Phone Number"
            value={
              phone ?? "Need to add phone number in core before activating"
            }
          />
        </dl>
      </div>
      <br />
      <div className="px-4 sm:px-0">
        <h3 className="text-base/7 font-semibold text-gray-900">Driver</h3>
      </div>
      <div className="mt-6 border-t border-gray-100">
        <dl className="divide-y divide-gray-100">
          <InfoRow label="First Name" value={Driver.firstName} />
          <InfoRow label="Last Name" value={Driver.lastName} />
          <InfoRow label="Email address" value={Driver.email} />
          <InfoRow label="Phone Number" value={Driver.phone} />
        </dl>
      </div>

      <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
        <button
          disabled={isLoading}
          onClick={GoBack}
          type="button"
          className="text-sm/6 font-semibold text-gray-900"
        >
          Back
        </button>
        <button
          onClick={onsubmit}
          disabled={isLoading}
          type="button"
          className={`rounded-md px-3 py-2 text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2
    ${
      isLoading
        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
        : "bg-indigo-600 text-white hover:bg-indigo-500 focus-visible:outline-indigo-600"
    }`}
        >
          {isLoading ? (
            <div className="w-5 h-5 border-4 border-t-transparent border-white rounded-full animate-spin mx-auto"></div>
          ) : (
            "Submit"
          )}
        </button>
      </div>
    </div>
  );
};

const InfoRow = ({ label, value }) => (
  <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
    <dt className="text-sm/6 font-medium text-gray-900">{label}</dt>
    <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
      {value}
    </dd>
  </div>
);

export default PolicyOwnerReview;
